module.exports = __webpack_public_path__ + "static/img/ea7926e608930d5e79d887f79f7b04d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = dLd/
// module chunks = 1